import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { ApolloResponse } from '@/interfaces/apollo'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import { showErrors } from '@/utils/snack'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppSearch from '@/components/AppSearch.vue'
import AppRefresh from '@/components/AppRefresh.vue'
import AppTabs from '@/components/AppTabs.vue'
import CarrierDialog from '@/modules/Carrier/scripts/carrier-dialog'
import CarrierProductDetailDetail from '@/modules/CarrierProduct/views/detail.vue'
import { getCarrierProduct } from '@/modules/CarrierProduct/gql/carrier-product.gql'

@Component({
  components: {
    AppBreadcrumbs,
    AppSearch,
    AppRefresh,
    AppTabs,
    CarrierProductDetailDetail
  }
})
export default class CarrierProductDetail extends mixins(CarrierDialog) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Setting'
    },
    {
      text: 'Insurance Products',
      to: { name: 'CarrierProductList' }
    }
  ]

  carrierProduct: CarrierProduct | null = null

  tabActive = 0
  tabItems = [
    {
      title: 'Details',
      route: 'CarrierProductDetailDetail'
    },
    {
      title: 'Commission Info (GA)',
      route: 'CarrierProductDetailCommissionGA'
    },
    {
      title: 'Commission Info (Direct)',
      route: 'CarrierProductDetailCommissionDirect'
    },
    {
      title: 'Policies',
      route: 'CarrierProductDetailPolicy'
    },
    {
      title: 'Quotes',
      route: 'CarrierProductDetailQuotes'
    },
    {
      title: 'Additional',
      route: 'CarrierProductDetailAdditional'
    }
  ]
  get tabTitles () {
    return this.tabItems.map(item => item.title)
  }

  mounted () {
    const { name } = this.$route
    const index = this.$R.findIndex((item: any) => item.route === name)(this.tabItems)
    this.tabActive = index
    this.getCarrierProduct()
  }

  async getCarrierProduct () {
    const carrierProductId = Number(this.$route.params.id)
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCarrierProduct,
        variables: {
          carrierProductId
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.carrierProduct = result.data.getCarrierProduct as CarrierProduct
      this.breadcrumbs.push({
        text: this.carrierProduct.name
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
  clickTabHandler (index: number) {
    const item = this.tabItems[index]
    if (item.route) {
      this.$router.push({
        name: item.route
      })
    }
  }
  async deleteCarrierProductConfirm () {
    await this.deleteCarrierProductPost()
    if (this.carrierProduct && this.carrierProduct.carrier) {
      this.$router.replace({
        name: 'CarrierDetailRelated',
        params: {
          id: this.carrierProduct.carrier.id + ''
        }
      })
    } else {
      this.$router.replace({
        name: 'CarrierProductList'
      })
    }
  }
}
